import { useState, useEffect } from "react";
import {
  FaChevronDown,
  FaChevronUp,
  FaRupeeSign,
  FaBars,
  FaTimes,
  FaHeart,
  FaRegHeart,
} from "react-icons/fa";
import { TfiClose } from "react-icons/tfi";
import { SlArrowDown, SlArrowUp } from "react-icons/sl";
import { FaChevronLeft, FaChevronRight, FaSearch } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ReactSlider from "react-slider";
import { addToWishlist, removeFromWishlist, getWishlistProducts } from "../../utils/wishlistUtils";
import Login from "../Layout/Login/Login";


export default function ProductList11({
  data,
  totalItems,
  subcategoryName,
  isReset,
  fetchNextPage,
  hasMore,
  isFetching,
  onResetFilters,
}) {
  const [openSections, setOpenSections] = useState({});
  const [selectedOptions, setSelectedOptions] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Select");
  const [hoveredImage, setHoveredImage] = useState({});
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [productsPerRow, setProductsPerRow] = useState(3);

  const [autoScrollImages, setAutoScrollImages] = useState({});
  const [intervals, setIntervals] = useState({});

  const [productImageAnimation, setProductImageAnimation] = useState(
    "On Hover Scrolling "
  );

  const [filters, setFilters] = useState([]);
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();
  const dimensionRanges = {
    Height: { min: 10, max: 200 },
    Width: { min: 20, max: 300 },
    Depth: { min: 5, max: 100 },
  };

  const [favorites, setFavorites] = useState({});
  const [vibratingHearts, setVibratingHearts] = useState({});
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const openLoginModal = () => setIsLoginModalOpen(true);
  const closeLoginModal = () => setIsLoginModalOpen(false);
  const [webFont, setWebFont] = useState("");
  const [themeColor, setThemeColor] = useState("");
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [mainCategoryId, setMainCategoryId] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");



  useEffect(() => {
    if (products.length === 0) return; // Skip if no products

    const sortedProducts = [...products]; // Create a copy to avoid mutating state

    switch (selectedOption) {
      case "Price Low to High":
        sortedProducts.sort((a, b) => {
          const priceA = parseFloat(a.price.replace("₹", ""));
          const priceB = parseFloat(b.price.replace("₹", ""));
          return priceA - priceB;
        });
        break;

      case "Price High to Low":
        sortedProducts.sort((a, b) => {
          const priceA = parseFloat(a.price.replace("₹", ""));
          const priceB = parseFloat(b.price.replace("₹", ""));
          return priceB - priceA;
        });
        break;

      case "New In":
        sortedProducts.sort((a, b) => {
          // Prioritize products with exclusive/netsustain true
          if (a.exclusive && !b.exclusive) return -1;
          if (!a.exclusive && b.exclusive) return 1;
          return 0; // Maintain order if both are same
        });
        break;

      case "Select":
        // No sorting needed, keep original order
        break;

      default:
        break;
    }

    setProducts(sortedProducts); // Update state with sorted products
  }, [selectedOption, products.length]); // Depend on selectedOption and products.length


  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setWebFont(parsedStyle.web_font);
      setThemeColor(parsedStyle.web_theme_colour)
    }
  }, []);

  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }


  const toggleFavorite = async (id, productId) => {
    const customerId = sessionStorage.getItem("accessToken");
    if (!customerId) {
      setVibratingHearts((prev) => ({ ...prev, [id]: true }));
      setTimeout(() => {
        setVibratingHearts((prev) => ({ ...prev, [id]: false }));
        openLoginModal();
      }, 500);
      return;
    }

    const isNowFavorite = !favorites[id];
    setFavorites((prev) => ({ ...prev, [id]: isNowFavorite }));

    try {
      if (isNowFavorite) {
        await addToWishlist(productId);
      } else {
        await removeFromWishlist(productId);
      }
    } catch (error) {
      console.error("Error toggling wishlist:", error);
      setFavorites((prev) => ({ ...prev, [id]: !isNowFavorite }));
      setVibratingHearts((prev) => ({ ...prev, [id]: true }));
      setTimeout(() => setVibratingHearts((prev) => ({ ...prev, [id]: false })), 500);
    }
  };

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_filter_menu`,
          {
            admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          }
        );

        if (response.data?.status === 1) {
          const data2 = response.data;

          const priceRange =
            data2.price_list && data2.price_list.length > 0
              ? {
                min: parseFloat(data2.price_list[0].min_price),
                max: Math.max(parseFloat(data2.price_list[0].max_price), 100000),
              }
              : { min: 0, max: 100000 };


          const apiFilters = data2.allfiltermenus.map(
            (filter) => filter.filter_menu_name
          );

          const updatedFilters = apiFilters.map((apiFilter) => {
            let options = [];
            let type = "checkbox";
            let sliderRange = null;

            switch (apiFilter) {
              case "Price":
                type = "slider";
                sliderRange = priceRange;
                break;

              case "Thickness":
                type = "slider";
                break;

              case "Manufacturers":
                options =
                  data2.manufacturer_list?.map((item) => ({
                    label: item.manufacturer_name,
                    value: item._id,
                  })) || [];
                break;

              case "Size":
                options =
                  data2.size_list?.map((item) => ({
                    label: item.size,
                    value: item.size_auto_id,
                  })) || [];
                break;

              case "Brand":
                options =
                  data2.brand_list?.map((item) => ({
                    label: item.brand_name,
                    value: item.brand_auto_id,
                  })) || [];
                break;

              case "Color":
                options =
                  data2.color_list?.map((item) => ({
                    label: item.color_name,
                    value: item._id,
                  })) || [];
                break;

              case "Material":
                options =
                  data2.material_list?.map((item) => ({
                    label: item.material_name,
                    value: item._id,
                  })) || [];
                break;

              case "Discount":
                options =
                  data2.discount_list?.map((item) => ({
                    label: `${item.discount_percent}%`,
                    value: item._id,
                  })) || [];
                break;

              case "Firmness":
                options =
                  data2.firmness_list?.map((item) => ({
                    label: item.unit,
                    value: item._id,
                  })) || [];
                break;

              case "Out of stock":
                options = [{ label: "Include out of stock", value: true }];
                break;

              case "Moq":
                options = Array.from({ length: 10 }, (_, i) => ({
                  label: (i + 1).toString(),
                  value: i + 1,
                }));
                break;

              default:
                // Leave default as checkbox
                options = [];
            }

            return {
              title: apiFilter,
              type,
              options,
              sliderRange,
            };
          });

          const dimensionInApi = apiFilters.some(
            (name) => name.toLowerCase() === "dimension"
          );

          if (dimensionInApi) {
            // Remove any existing "Dimension" filter to avoid duplication
            const cleanedFilters = updatedFilters.filter(
              (f) => f.title.toLowerCase() !== "dimension"
            );

            // Push our custom "Dimension" group
            cleanedFilters.push({
              title: "Dimension",
              type: "dimension-group",
              options: [
                { name: "Height", type: "slider" },
                { name: "Width", type: "slider" },
                { name: "Depth", type: "slider" },
              ],
            });

            setFilters(cleanedFilters);
          } else {
            // If "Dimension" not found in API, just use the filters as-is
            setFilters(updatedFilters);
          }
        }
      } catch (error) {
        console.error("Error fetching filters:", error);
      }
    };

    fetchFilters();
  }, []);

  const mapProducts = (data1) => {
    const baseUrl =
      "https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/";

    return data1.map((product, index) => ({
      id: index + 1,
      product_auto_id: product.product_auto_id,
      name: product.product_name || "Unknown Product",
      description: product.description || "No description available",
      weight: product.weight || "N/A",
      price: `${product.final_product_price || "0"}`,
      originalPrice: `₹${product.product_price || "0"}`,
      discount: product.offer_percentage
        ? `${product.offer_percentage}% off`
        : "No discount",
      delivery:
        product.time && product.time_unit
          ? `${product.time} ${product.time_unit}`
          : "Delivery info not available",
      image:
        product.product_images?.length > 0
          ? `${baseUrl}${product.product_images[0].product_image}`
          : "default-image.jpg",
      hoverImage:
        product.product_images?.length > 1
          ? `${baseUrl}${product.product_images[1].product_image}`
          : `${baseUrl}${product.product_images?.[0]?.product_image}` ||
          "default-image.jpg",
      exclusive: product.new_arrival === "Yes",
      netsustain: product.new_arrival === "Yes",
      colors: product.color_code ? [product.color_code] : [],
    }));
  };

  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {

      // Capture category context once
      setMainCategoryId(data[0]?.main_category_auto_id || "");
      setSubCategoryId(data[0]?.sub_category_auto_id || "");

      const mapped = mapProducts(data);
      setProducts((prev) => {
        if (isReset) {
          return mapped;
        } else {
          const existingIds = new Set(prev.map(p => p.product_auto_id));
          const newProducts = mapped.filter(p => !existingIds.has(p.product_auto_id));
          return [...prev, ...newProducts];
        }
      });
    }
  }, [data]);


  const syncWishlist = async (productList) => {
    const token = sessionStorage.getItem("accessToken");
    if (!token || !Array.isArray(productList)) return;

    try {
      const wishlist = await getWishlistProducts();

      const wishlistSet = new Set(
        wishlist.map((w) => String(w.product_auto_id))
      );

      const updatedFavorites = {};
      productList.forEach((product) => {
        updatedFavorites[product.id] = wishlistSet.has(
          String(product.product_auto_id)
        );
      });

      setFavorites(updatedFavorites);
    } catch (error) {
      console.error("Wishlist sync failed:", error);
    }
  };
  useEffect(() => {
    if (products.length > 0) {
      syncWishlist(products);
    }
  }, [products]);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 1500 &&
        !isFetching &&
        hasMore
      ) {
        fetchNextPage(); // ← This comes from props
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [fetchNextPage, isFetching, hasMore]);

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);

      setProductsPerRow(parseInt(parsedStyle.product_per_row));
      setProductImageAnimation(parsedStyle.product_image_animation);
    }
  }, []);

  useEffect(() => {
    if (productImageAnimation === "Auto Scrolling") {
      products.forEach((product) => {
        const interval = setInterval(() => {
          setAutoScrollImages((prev) => ({
            ...prev,
            [product.id]: prev[product.id] ? false : true, // Toggle between image & hoverImage
          }));
        }, 3000);

        setIntervals((prev) => ({
          ...prev,
          [product.id]: interval,
        }));
      });
    }

    return () => {
      Object.values(intervals).forEach(clearInterval);
      setIntervals({});
    };
  }, [productImageAnimation]);

  const options = [
    { value: "Newest_In", label: "New In" },
    { value: "Price_Low to_High", label: "Price Low to High" },
    { value: "Price_High to_Low", label: "Price High to Low" },
  ];

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleSelectOption = (label) => {
    setSelectedOption(label);
    setIsOpen(false);
  };

  const removeFilter = (title) => {
    setSelectedOptions((prev) => {
      const newOptions = { ...prev };
      delete newOptions[title];

      // If no filters left, reset products
      if (Object.keys(newOptions).length === 0) {
        setProducts([]);
        onResetFilters?.();
      }

      return newOptions;
    });
  };

  const handleMouseEnter = (productId) => {
    setHoveredImage((prev) => ({ ...prev, [productId]: true }));
  };

  const handleMouseLeave = (productId) => {
    setHoveredImage((prev) => ({ ...prev, [productId]: false }));
  };

  const [activeImage, setActiveImage] = useState({});

  const handleArrowClick = (productId, direction) => {
    setActiveImage((prev) => {
      const currentImage = prev[productId] || "image"; // Default to 'image' if not set
      return {
        ...prev,
        [productId]: currentImage === "image" ? "hoverImage" : "image", // Toggle between image and hoverImage
      };
    });
  };

  const applyFilters = async () => {
    const admin_auto_id = sessionStorage.getItem("admin_auto_id");
    const app_type_id = sessionStorage.getItem("app_type_id");
    const user_auto_id =
      sessionStorage.getItem("accessToken") ||
      sessionStorage.getItem("admin_auto_id");
    const country = localStorage.getItem("country_name") || "India";

    const formData = new FormData();
    formData.append("admin_auto_id", admin_auto_id);
    formData.append("app_type_id", app_type_id);
    formData.append("customer_auto_id", user_auto_id);
    formData.append("country", country);
    formData.append("limit", 10);
    formData.append("page_number", 1);
    formData.append("main_category_id", mainCategoryId);
    formData.append("sub_category_id", subCategoryId);

    Object.entries(selectedOptions).forEach(([key, value]) => {
      // Handle range filters (sliders)
      if (value?.min !== undefined && value?.max !== undefined) {
        switch (key) {
          case "Price":
            formData.append("min_price", value.min);
            formData.append("max_price", value.max);
            break;
          case "Thickness":
            formData.append("min_thickness", value.min);
            formData.append("max_thickness", value.max);
            break;
          case "Dimension-Height":
            formData.append("min_height", value.min);
            formData.append("max_height", value.max);
            break;
          case "Dimension-Width":
            formData.append("min_width", value.min);
            formData.append("max_width", value.max);
            break;
          case "Dimension-Depth":
            formData.append("min_depth", value.min);
            formData.append("max_depth", value.max);
            break;
          default:
            break;
        }
      }

      // Handle checkbox groups
      if (Array.isArray(value)) {
        const valuesOnly = value.map((v) => v.value);
        const labelsOnly = value.map((v) => v.label);

        switch (key) {
          case "Brand":
            formData.append("brand_id", valuesOnly.join("|"));
            break;
          case "Size":
            formData.append("size_id", valuesOnly.join("|"));
            break;
          case "Manufacturers":
            formData.append("manufacturer_name", labelsOnly.join("|"));
            break;
          case "Material":
            formData.append("material_name", labelsOnly.join("|"));
            break;
          case "Firmness":
            formData.append("firmness_type", labelsOnly.join("|"));
            break;
          case "Color":
            formData.append("color_name", labelsOnly.join("|"));
            break;
          case "Out of stock":
            if (valuesOnly.includes(true)) {
              formData.append("out_of_stock", true);
            }
            break;
          case "Discount":
            if (labelsOnly.length) {
              const maxDiscount = parseInt(labelsOnly[0]);
              formData.append("min_discount", 0);
              formData.append("max_discount", maxDiscount);
            }
            break;
          case "Moq":
            if (labelsOnly.length) {
              formData.append("moq", labelsOnly[0]);
            }
            break;
          default:
            break;
        }
      }
    });

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_filter_products`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status === 1) {
        const data3 = response.data.get_admin_filter_product_lists;
        const baseUrl =
          "https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/";

        const mappedProducts = data3.map((product, index) => ({
          id: index + 1, // Ensuring unique IDs
          product_auto_id: product.product_auto_id,
          name: product.product_name || "Unknown Product",
          description: product.description || "No description available",
          weight: product.weight || "N/A",
          price: `${product.final_product_price || "0"}`,
          originalPrice: `${product.product_price || "0"}`,
          discount: product.offer_percentage
            ? `${product.offer_percentage}% off`
            : "No discount",
          delivery:
            product.time && product.time_unit
              ? `${product.time} ${product.time_unit}`
              : "Delivery info not available",
          image:
            product.product_images?.length > 0
              ? `${baseUrl}${product.product_images[0].product_image}`
              : "default-image.jpg", // First image as main
          hoverImage:
            product.product_images?.length > 1
              ? `${baseUrl}${product.product_images[1].product_image}`
              : `${baseUrl}${product.product_images?.[0]?.product_image}` ||
              "default-image.jpg", // Second image as hover, fallback to first
          exclusive: product.new_arrival === "Yes",
          netsustain: product.new_arrival === "Yes",
          colors: product.color_code ? [product.color_code] : [],
        }));

        setProducts(mappedProducts);
        setFiltersApplied(true);

        // setFiltersApplied(true);
      } else {
        setProducts([]);
        // setFiltersApplied(true);
      }
    } catch (error) {
      console.error("Error applying filters:", error);
    }
  };

  const handleClearFilters = () => {
    setSelectedOptions({});
    setSelectedOption("Select");
    setProducts([]);
    setFiltersApplied(false);   // ✅ reset flag
    onResetFilters?.();
  };


  return (
    <div className={`relative flex flex-col md:flex-row ${webFont}`}>
      <style>
        {`
          @keyframes vibrate {
            0% { transform: translate(0); }
            20% { transform: translate(-2px, 2px); }
            40% { transform: translate(-2px, -2px); }
            60% { transform: translate(2px, 2px); }
            80% { transform: translate(2px, -2px); }
            100% { transform: translate(0); }
          }
          .vibrate {
            animation: vibrate 0.3s linear;
          }
        `}
      </style>
      {/* Sidebar */}
      <div
        className={`
          ${isSidebarOpen ? "fixed translate-x-0" : "fixed -translate-x-full"}
          md:sticky md:translate-x-0
          pb-20 top-0 left-0 z-20 w-80 md:w-96 bg-white
          h-screen md:h-[calc(100vh-2rem)]
          transition-transform transform overflow-y-auto
        `}
        style={{
          scrollbarWidth: "none",          // Firefox
          msOverflowStyle: "none",         // IE 10+
        }}
      >
        {/* Hide scrollbar in WebKit browsers */}
        <style>
          {`
          div::-webkit-scrollbar {
            display: none;
          }
        `}
        </style>
        <button
          className="absolute text-gray-700 top-4 left-4 md:hidden"
          onClick={() => setIsSidebarOpen(false)}
        >
          <FaTimes size={22} />
        </button>

        {/* <div className="w-full px-4 ">
          <h6 className="mb-4 text-gray-400">{totalItems} Results</h6>
        </div> */}

        <div className="flex justify-end gap-1 p-2 border-b-2">
          <button className="p-2 text-white" onClick={applyFilters}
            style={{ backgroundColor: themeColor }}
            onMouseEnter={(e) => {
              const darkenedColor = darkenHexColor(themeColor, 0.15); // darken by 15%
              e.currentTarget.style.backgroundColor = darkenedColor;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = themeColor;
            }}>
            Apply Filter
          </button>
          <button
            className="p-2 text-white "
            onClick={handleClearFilters}
            style={{ backgroundColor: themeColor }}
            onMouseEnter={(e) => {
              const darkenedColor = darkenHexColor(themeColor, 0.15); // darken by 15%
              e.currentTarget.style.backgroundColor = darkenedColor;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = themeColor;
            }}
          >
            Clear Filters
          </button>
        </div>

        {filters.map((filter) => (
          <div key={filter.title} className="px-4 py-3 mt-1 mb-1 border-b-2">
            {/* Toggle Section Header */}
            <div
              className="flex items-center justify-between font-bold text-gray-800 cursor-pointer"
              onClick={() =>
                setOpenSections((prev) => ({
                  ...prev,
                  [filter.title]: !prev[filter.title],
                }))
              }
            >
              <div>{filter.title}</div>
              {openSections[filter.title] ? <FaChevronUp /> : <FaChevronDown />}
            </div>

            {/* Collapsed Preview */}
            {!openSections[filter.title] && (
              <div className="mt-1 text-sm text-gray-500">
                {selectedOptions[filter.title]
                  ? JSON.stringify(selectedOptions[filter.title])
                  : "All"}
              </div>
            )}

            {/* Expanded Section */}
            {openSections[filter.title] && (
              <div className="p-2 mt-2 space-y-2 overflow-y-auto border-gray-300 rounded-md max-h-48">
                {filter.type === "dimension-group" ? (
                  filter.options.map((dim) => {
                    const dimKey = `${filter.title}-${dim.name}`;
                    const { min, max } = dimensionRanges[dim.name] || {
                      min: 0,
                      max: 100,
                    };
                    const values = [
                      selectedOptions[dimKey]?.min ?? min,
                      selectedOptions[dimKey]?.max ?? max,
                    ];

                    return (
                      <div key={dim.name} className="mb-4">
                        <label className="block mb-1 text-sm font-medium text-gray-700">
                          {dim.name}
                        </label>
                        <div className="flex justify-between mb-1 text-sm">
                          <span>{values[0]}</span>
                          <span>{values[1]}</span>
                        </div>
                        <ReactSlider
                          className="w-full h-2 bg-gray-300 rounded"
                          thumbClassName="h-4 w-4 bg-blue-600 rounded-full cursor-pointer"
                          trackClassName="bg-gray-300 h-4 rounded-lg"
                          min={min}
                          max={max}
                          step={1}
                          value={values}
                          onChange={([newMin, newMax]) =>
                            setSelectedOptions((prev) => ({
                              ...prev,
                              [dimKey]: { min: newMin, max: newMax },
                            }))
                          }
                          withTracks={true}
                          pearling
                          minDistance={1}
                        />
                      </div>
                    );
                  })
                ) : filter.type === "slider" ? (
                  <div className="mb-4">
                    <label className="block mb-1 text-sm font-medium text-gray-700">
                      Range
                    </label>
                    <div className="flex justify-between mb-1 text-sm">
                      <span>
                        {selectedOptions[filter.title]?.min ??
                          filter.sliderRange?.min ??
                          0}
                      </span>
                      <span>
                        {selectedOptions[filter.title]?.max ??
                          filter.sliderRange?.max ??
                          100}
                      </span>
                    </div>
                    <ReactSlider
                      className="w-full h-2 bg-gray-300 rounded"
                      thumbClassName="h-4 w-4 bg-blue-600 rounded-full cursor-pointer"
                      trackClassName="bg-gray-300 h-4 rounded-lg"
                      min={filter.sliderRange?.min ?? 0}
                      max={filter.sliderRange?.max ?? 100}
                      step={1}
                      value={[
                        selectedOptions[filter.title]?.min ??
                        filter.sliderRange?.min ??
                        0,
                        selectedOptions[filter.title]?.max ??
                        filter.sliderRange?.max ??
                        100,
                      ]}
                      onChange={([newMin, newMax]) =>
                        setSelectedOptions((prev) => ({
                          ...prev,
                          [filter.title]: { min: newMin, max: newMax },
                        }))
                      }
                      withTracks
                      pearling
                      minDistance={1}
                    />
                  </div>
                ) : (
                  filter.options.map((option) => (
                    <label
                      key={option.value}
                      className="flex items-center space-x-2 text-gray-700"
                    >
                      <input
                        type="checkbox"
                        className="form-checkbox"
                        onChange={() => {
                          setSelectedOptions((prev) => {
                            const prevOptions = prev[filter.title] || [];
                            const exists = prevOptions.some(
                              (o) => o.value === option.value
                            );
                            return {
                              ...prev,
                              [filter.title]: exists
                                ? prevOptions.filter(
                                  (o) => o.value !== option.value
                                )
                                : [...prevOptions, option],
                            };
                          });
                        }}
                        checked={
                          selectedOptions[filter.title]?.some(
                            (o) => o.value === option.value
                          ) || false
                        }
                      />
                      <span>{option.label}</span>
                    </label>
                  ))
                )}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Overlay when sidebar is open on mobile */}
      {isSidebarOpen && (
        <div
          className="fixed z-50 md:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      <div className="flex-1 p-6">
        {/* Selected Filters Section */}
        <div className="flex flex-col items-start justify-between w-full gap-2 py-2 mb-3 md:flex-row md:items-center">
          {/* Selected Filters Display */}
          <div className="flex flex-wrap gap-2">
            {Object.entries(selectedOptions).map(([title, option]) => {
              let displayText = "";

              if (typeof option === "object" && option !== null) {
                // Slider with min and max
                if ("min" in option && "max" in option) {
                  displayText = `${title}: ${option.min} - ${option.max}`;
                }
                // Checkbox with array of selected options
                else if (Array.isArray(option)) {
                  displayText = `${title}: ${option
                    .map((o) => o.label)
                    .join(", ")}`;
                }
              } else {
                // Single string or value
                displayText = `${title}: ${option}`;
              }

              return (
                <div
                  key={title}
                  className="
    group flex items-center gap-2
    px-4 py-2
    text-sm font-semibold
    
    bg-[#fff4ee]
    border border-[#ffd5bf]
    text-[#6b3e2e]
    shadow-sm
    transition-all duration-300
    hover:bg-[#ffe6d6]
    hover:shadow-md
  "
                >
                  {/* Filter text */}
                  <span className="tracking-wide">
                    {displayText}
                  </span>

                  {/* Close button */}
                  <button
                    onClick={() => removeFilter(title)}
                    className="
      flex items-center justify-center
      w-6 h-6
      rounded-full
      bg-white
      border border-[#ffc2a1]
      text-[#a05a3b]
      transition-all duration-200
      hover:bg-[#ffb38a]
      hover:text-white
      hover:rotate-90
      hover:shadow
    "
                    aria-label="Remove filter"
                  >
                    <TfiClose size={11} />
                  </button>
                </div>
              );
            })}
          </div>
          <div className="w-full px-2">
            <h1 className="mb-4 font-bold text-black md:hidden">
              {subcategoryName}
            </h1>
          </div>

          {/* Mobile Menu Button + Dropdown */}
          <div className="flex items-center justify-between w-full gap-3">

            {/* Filter Button */}
            <button
              className="flex items-center gap-2 px-3 text-gray-700 bg-white w-22 h-9 md:hidden"
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            >
              <FaSearch size={16} className="text-gray-600" />
              <span className="text-sm font-medium">Filter</span>
            </button>

            {/* Select Dropdown */}
            <div className="relative">
              {/* <div
      className="flex items-center justify-between px-3 border rounded-md cursor-pointer w-22 h-9"
      onClick={toggleDropdown}
    >
      <span className="text-sm">{selectedOption}</span>
      {isOpen ? (
        <SlArrowUp className="text-lg" />
      ) : (
        <SlArrowDown className="text-lg" />
      )}
    </div> */}
              <h6 className="mt-2 text-sm text-gray-400 py-auto">
                {filtersApplied ? products.length : totalItems} Products
              </h6>


              {isOpen && (
                <div className="left-0 right-0 z-30 mt-1 bg-white border border-gray-600 rounded-md shadow-lg ">
                  {options.map((option) => (
                    <div
                      key={option.value}
                      className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                      onClick={() => handleSelectOption(option.label)}
                    >
                      {option.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

        </div>
        {/* No Products Found */}
        {!isFetching && products.length === 0 && (
          <div className="flex flex-col items-center justify-center py-20 text-center">
            <img
              src="https://cdn-icons-png.flaticon.com/512/7486/7486740.png"
              alt="No products"
              className="mb-4 w-28 h-28 opacity-70"
            />
            <h2 className="text-xl font-semibold text-gray-700">
              No products found
            </h2>
            <p className="mt-2 text-gray-500">
              Try adjusting your filters or clear them to see products.
            </p>

            <button
              onClick={handleClearFilters}
              className="px-6 py-2 mt-4 text-white rounded-md"
              style={{ backgroundColor: themeColor }}
            >
              Clear Filters
            </button>
          </div>
        )}

        {/* Product Cards Section */}

        {/* 1 products per row */}
        {productsPerRow === 1 && (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-1 md:gap-10 gap-y-10">
            {products.map((product) => (
              <div
                key={product.product_auto_id}
                className="relative overflow-hidden"
                onClick={() =>
                  navigate(`/product-detail/${product.product_auto_id}`)
                }
              >
                <img
                  onMouseEnter={() => {
                    if (productImageAnimation === "On Hover Scrolling") {
                      handleMouseEnter(product.id);
                    }
                  }}
                  onMouseLeave={() => {
                    if (productImageAnimation === "On Hover Scrolling") {
                      handleMouseLeave(product.id);
                    }
                  }}
                  src={
                    productImageAnimation === "Auto Scrolling"
                      ? autoScrollImages[product.id] // If auto scrolling, toggle image/hoverImage based on autoScrollImages state
                        ? product.hoverImage
                        : product.image
                      : productImageAnimation === "On Hover Scrolling" // On Hover Scrolling
                        ? hoveredImage[product.id] // Use hoverImage if hoveredImage state is true
                          ? product.hoverImage
                          : product.image
                        : activeImage[product.id] === "hoverImage" // Arrow click logic
                          ? product.hoverImage
                          : product.image
                  }
                  alt={product.name}
                  className="w-full h-[375px] md:h-[475px] object-cover"
                />

                <button
                  className={`absolute top-2 right-2 p-2 border rounded-full bg-white z-20 ${vibratingHearts[product.id] ? "vibrate" : ""
                    }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleFavorite(product.id, product.product_auto_id);
                  }}
                >
                  {favorites[product.id] ? (
                    <FaHeart className="text-xl text-red-500" />
                  ) : (
                    <FaRegHeart className="text-xl text-gray-600" />
                  )}
                </button>

                {productImageAnimation === "On Arrow Click" && (
                  <>
                    <div
                      className="absolute z-10 text-gray-600 transform -translate-y-1/2 cursor-pointer top-56 left-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleArrowClick(product.id, "left");
                      }} // Left arrow click handler
                    >
                      <FaChevronLeft size={30} />
                    </div>
                    <div
                      className="absolute z-10 text-gray-600 transform -translate-y-1/2 cursor-pointer top-56 right-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleArrowClick(product.id, "right");
                      }} // Right arrow click handler
                    >
                      <FaChevronRight size={30} />
                    </div>
                  </>
                )}

                <div className="py-2">
                  <h5 className="text-lg font-bold truncate">{product.name}</h5>
                  <h6 className="text-sm text-gray-500 truncate">
                    {product.description}
                  </h6>
                  <p className="flex items-center mt-3 mb-0 font-semibold text-black">
                    <FaRupeeSign className="mr-1" /> {product.price}
                  </p>
                  <div className="flex flex-col">
                    {product.exclusive && (
                      <span className="px-1 text-gray-500 text-md">
                        EXCLUSIVE
                      </span>
                    )}
                    {product.netsustain && (
                      <span className="px-1 text-md" style={{ color: themeColor }}>
                        NET SUSTAIN
                      </span>
                    )}
                  </div>
                  <div className="flex mt-2 space-x-2">
                    {product.colors.map((color, index) => (
                      <span
                        key={index}
                        className="w-4 h-4 rounded-full"
                        style={{ backgroundColor: color }}
                      ></span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* 2 products per row */}
        {productsPerRow === 2 && (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-2 md:gap-10 gap-y-10">
            {products.map((product) => (
              <div
                key={product.product_auto_id}
                className="relative overflow-hidden"
                onClick={() =>
                  navigate(`/product-detail/${product.product_auto_id}`)
                }
              >
                <img
                  onMouseEnter={() => {
                    if (productImageAnimation === "On Hover Scrolling") {
                      handleMouseEnter(product.id);
                    }
                  }}
                  onMouseLeave={() => {
                    if (productImageAnimation === "On Hover Scrolling") {
                      handleMouseLeave(product.id);
                    }
                  }}
                  src={
                    productImageAnimation === "Auto Scrolling"
                      ? autoScrollImages[product.id] // If auto scrolling, toggle image/hoverImage based on autoScrollImages state
                        ? product.hoverImage
                        : product.image
                      : productImageAnimation === "On Hover Scrolling" // On Hover Scrolling
                        ? hoveredImage[product.id] // Use hoverImage if hoveredImage state is true
                          ? product.hoverImage
                          : product.image
                        : activeImage[product.id] === "hoverImage" // Arrow click logic
                          ? product.hoverImage
                          : product.image
                  }
                  alt={product.name}
                  className="w-full h-[375px] md:h-[475px] object-cover"
                />
                <button
                  className={`absolute top-2 right-2 p-2 border rounded-full bg-white z-20 ${vibratingHearts[product.id] ? "vibrate" : ""
                    }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleFavorite(product.id, product.product_auto_id);
                  }}
                >
                  {favorites[product.id] ? (
                    <FaHeart className="text-xl text-red-500" />
                  ) : (
                    <FaRegHeart className="text-xl text-gray-600" />
                  )}
                </button>
                {productImageAnimation === "On Arrow Click" && (
                  <>
                    <div
                      className="absolute z-10 text-gray-600 transform -translate-y-1/2 cursor-pointer top-56 left-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleArrowClick(product.id, "left");
                      }} // Left arrow click handler
                    >
                      <FaChevronLeft size={30} />
                    </div>
                    <div
                      className="absolute z-10 text-gray-600 transform -translate-y-1/2 cursor-pointer top-56 right-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleArrowClick(product.id, "right");
                      }} // Right arrow click handler
                    >
                      <FaChevronRight size={30} />
                    </div>
                  </>
                )}

                <div className="py-2">
                  <h5 className="text-lg font-bold truncate">{product.name}</h5>
                  <h6 className="text-sm text-gray-500 truncate">
                    {product.description}
                  </h6>
                  <p className="flex items-center mt-3 mb-0 font-semibold text-black">
                    <FaRupeeSign className="mr-1" /> {product.price}
                  </p>
                  <div className="flex flex-col">
                    {product.exclusive && (
                      <span className="px-1 text-gray-500 text-md">
                        EXCLUSIVE
                      </span>
                    )}
                    {product.netsustain && (
                      <span className="px-1 text-md" style={{ color: themeColor }}>
                        NET SUSTAIN
                      </span>
                    )}
                  </div>
                  <div className="flex mt-2 space-x-2">
                    {product.colors.map((color, index) => (
                      <span
                        key={index}
                        className="w-4 h-4 rounded-full"
                        style={{ backgroundColor: color }}
                      ></span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* 3 products per row */}
        {productsPerRow === 3 && (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 md:gap-10 gap-y-10">
            {products.map((product) => (
              <div
                key={product.product_auto_id}
                className="relative overflow-hidden"
                onClick={() =>
                  navigate(`/product-detail/${product.product_auto_id}`)
                }
              >
                <img
                  onMouseEnter={() => {
                    if (productImageAnimation === "On Hover Scrolling") {
                      handleMouseEnter(product.id);
                    }
                  }}
                  onMouseLeave={() => {
                    if (productImageAnimation === "On Hover Scrolling") {
                      handleMouseLeave(product.id);
                    }
                  }}
                  src={
                    productImageAnimation === "Auto Scrolling"
                      ? autoScrollImages[product.id] // If auto scrolling, toggle image/hoverImage based on autoScrollImages state
                        ? product.hoverImage
                        : product.image
                      : productImageAnimation === "On Hover Scrolling" // On Hover Scrolling
                        ? hoveredImage[product.id] // Use hoverImage if hoveredImage state is true
                          ? product.hoverImage
                          : product.image
                        : activeImage[product.id] === "hoverImage" // Arrow click logic
                          ? product.hoverImage
                          : product.image
                  }
                  alt={product.name}
                  className="w-full h-[375px] md:h-[475px] object-cover"
                />
                <button
                  className={`absolute top-2 right-2 p-2 border rounded-full bg-white z-20 ${vibratingHearts[product.id] ? "vibrate" : ""
                    }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleFavorite(product.id, product.product_auto_id);
                  }}
                >
                  {favorites[product.id] ? (
                    <FaHeart className="text-xl text-red-500" />
                  ) : (
                    <FaRegHeart className="text-xl text-gray-600" />
                  )}
                </button>
                {productImageAnimation === "On Arrow Click" && (
                  <>
                    <div
                      className="absolute z-10 text-gray-600 transform -translate-y-1/2 cursor-pointer top-56 left-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleArrowClick(product.id, "left");
                      }} // Left arrow click handler
                    >
                      <FaChevronLeft size={30} />
                    </div>
                    <div
                      className="absolute z-10 text-gray-600 transform -translate-y-1/2 cursor-pointer top-56 right-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleArrowClick(product.id, "right");
                      }} // Right arrow click handler
                    >
                      <FaChevronRight size={30} />
                    </div>
                  </>
                )}
                <div className="py-2">
                  <h5 className="text-lg font-bold truncate">{product.name}</h5>
                  <h6 className="text-sm text-gray-500 truncate">
                    {product.description}
                  </h6>
                  <p className="flex items-center mt-3 mb-0 font-semibold text-black">
                    <FaRupeeSign className="mr-1" /> {product.price}
                  </p>
                  <div className="flex flex-col">
                    {product.exclusive && (
                      <span className="px-1 text-gray-500 text-md">
                        EXCLUSIVE
                      </span>
                    )}
                    {product.netsustain && (
                      <span className="px-1 text-md" style={{ color: themeColor }}>
                        NET SUSTAIN
                      </span>
                    )}
                  </div>
                  <div className="flex mt-2 space-x-2">
                    {product.colors.map((color, index) => (
                      <span
                        key={index}
                        className="w-4 h-4 rounded-full"
                        style={{ backgroundColor: color }}
                      ></span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* 4 products per row */}
        {productsPerRow === 4 && (
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-2 md:grid-cols-4 md:gap-10 gap-y-10">
            {products.map((product) => (
              <div
                key={product.product_auto_id}
                className="relative overflow-hidden"
                onClick={() =>
                  navigate(`/product-detail/${product.product_auto_id}`)
                }
              >
                <img
                  onMouseEnter={() => {
                    if (productImageAnimation === "On Hover Scrolling") {
                      handleMouseEnter(product.id);
                    }
                  }}
                  onMouseLeave={() => {
                    if (productImageAnimation === "On Hover Scrolling") {
                      handleMouseLeave(product.id);
                    }
                  }}
                  src={
                    productImageAnimation === "Auto Scrolling"
                      ? autoScrollImages[product.id] // If auto scrolling, toggle image/hoverImage based on autoScrollImages state
                        ? product.hoverImage
                        : product.image
                      : productImageAnimation === "On Hover Scrolling" // On Hover Scrolling
                        ? hoveredImage[product.id] // Use hoverImage if hoveredImage state is true
                          ? product.hoverImage
                          : product.image
                        : activeImage[product.id] === "hoverImage" // Arrow click logic
                          ? product.hoverImage
                          : product.image
                  }
                  alt={product.name}
                  className="w-full h-[200px] md:h-[375px] object-cover"
                />
                <button
                  className={`absolute top-2 right-2 p-1 border rounded-full bg-white z-0 ${vibratingHearts[product.id] ? "vibrate" : ""
                    }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleFavorite(product.id, product.product_auto_id);
                  }}
                >
                  {favorites[product.id] ? (
                    <FaHeart className="text-xl text-red-500" />
                  ) : (
                    <FaRegHeart className="text-xl text-gray-600" />
                  )}
                </button>
                {productImageAnimation === "On Arrow Click" && (
                  <>
                    <div
                      className="absolute z-10 text-gray-600 transform -translate-y-1/2 cursor-pointer top-56 left-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleArrowClick(product.id, "left");
                      }} // Left arrow click handler
                    >
                      <FaChevronLeft size={30} />
                    </div>
                    <div
                      className="absolute z-10 text-gray-600 transform -translate-y-1/2 cursor-pointer top-56 right-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleArrowClick(product.id, "right");
                      }} // Right arrow click handler
                    >
                      <FaChevronRight size={30} />
                    </div>
                  </>
                )}

                <div className="py-2">
                  <h5 className="text-lg font-bold truncate">{product.name}</h5>
                  <h6 className="text-sm text-gray-500 truncate">
                    {product.description}
                  </h6>
                  <p className="flex items-center mt-3 mb-0 font-semibold text-black">
                    <FaRupeeSign className="mr-1" /> {product.price}
                  </p>
                  <div className="flex flex-col">
                    {product.exclusive && (
                      <span className="px-1 text-gray-500 text-md">
                        EXCLUSIVE
                      </span>
                    )}
                    {product.netsustain && (
                      <span className="px-1 text-md" style={{ color: themeColor }}>
                        NET SUSTAIN
                      </span>
                    )}
                  </div>
                  <div className="flex mt-2 space-x-2">
                    {product.colors.map((color, index) => (
                      <span
                        key={index}
                        className="w-4 h-4 rounded-full"
                        style={{ backgroundColor: color }}
                      ></span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* 5 products per row */}
        {productsPerRow === 5 && (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-5 md:gap-10 gap-y-10">
            {products.map((product) => (
              <div
                key={product.product_auto_id}
                className="relative overflow-hidden"
                onClick={() =>
                  navigate(`/product-detail/${product.product_auto_id}`)
                }
              >
                <img
                  onMouseEnter={() => {
                    if (productImageAnimation === "On Hover Scrolling") {
                      handleMouseEnter(product.id);
                    }
                  }}
                  onMouseLeave={() => {
                    if (productImageAnimation === "On Hover Scrolling") {
                      handleMouseLeave(product.id);
                    }
                  }}
                  src={
                    productImageAnimation === "Auto Scrolling"
                      ? autoScrollImages[product.id] // If auto scrolling, toggle image/hoverImage based on autoScrollImages state
                        ? product.hoverImage
                        : product.image
                      : productImageAnimation === "On Hover Scrolling" // On Hover Scrolling
                        ? hoveredImage[product.id] // Use hoverImage if hoveredImage state is true
                          ? product.hoverImage
                          : product.image
                        : activeImage[product.id] === "hoverImage" // Arrow click logic
                          ? product.hoverImage
                          : product.image
                  }
                  alt={product.name}
                  className="w-full h-[375px] md:h-[250px] object-cover"
                />
                <button
                  className={`absolute top-2 right-2 p-1 border rounded-full bg-white z-20 ${vibratingHearts[product.id] ? "vibrate" : ""
                    }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleFavorite(product.id, product.product_auto_id);
                  }}
                >
                  {favorites[product.id] ? (
                    <FaHeart className="text-xl text-red-500" />
                  ) : (
                    <FaRegHeart className="text-xl text-gray-600" />
                  )}
                </button>
                {productImageAnimation === "On Arrow Click" && (
                  <>
                    <div
                      className="absolute z-10 text-gray-600 transform -translate-y-1/2 cursor-pointer top-56 left-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleArrowClick(product.id, "left");
                      }} // Left arrow click handler
                    >
                      <FaChevronLeft size={30} />
                    </div>
                    <div
                      className="absolute z-10 text-gray-600 transform -translate-y-1/2 cursor-pointer top-56 right-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleArrowClick(product.id, "right");
                      }} // Right arrow click handler
                    >
                      <FaChevronRight size={30} />
                    </div>
                  </>
                )}

                <div className="py-2">
                  <h5 className="text-lg font-bold truncate">{product.name}</h5>
                  <h6 className="text-sm text-gray-500 truncate">
                    {product.description}
                  </h6>
                  <p className="flex items-center mt-3 mb-0 font-semibold text-black">
                    <FaRupeeSign className="mr-1" /> {product.price}
                  </p>
                  <div className="flex flex-col">
                    {product.exclusive && (
                      <span className="px-1 text-gray-500 text-md">
                        EXCLUSIVE
                      </span>
                    )}
                    {product.netsustain && (
                      <span className="px-1 text-md" style={{ color: themeColor }}>
                        NET SUSTAIN
                      </span>
                    )}
                  </div>
                  <div className="flex mt-2 space-x-2">
                    {product.colors.map((color, index) => (
                      <span
                        key={index}
                        className="w-4 h-4 rounded-full"
                        style={{ backgroundColor: color }}
                      ></span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        {isLoginModalOpen && (
          <Login isOpen={isLoginModalOpen} onClose={closeLoginModal} />
        )}
      </div>
    </div>
  );
}
